import { useQuery } from 'react-query';

import Api from '../../api/api';

export type PostsDto = {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
};

const getPosts = async (params: PostsDto) => {
  const [response, bodyOrError] = await Api.get(`posts`, params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

const useGetAllPosts = (params: PostsDto) => {
  return useQuery({
    queryKey: ['getPosts', params],
    queryFn: () => getPosts(params),
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};

export default useGetAllPosts;
